// extracted by mini-css-extract-plugin
export default {"container":"ChatHandlePane_container__Q5KTM","handleButton":"ChatHandlePane_handleButton__sDhx5","handleText":"ChatHandlePane_handleText__hZ46t"};